import { Getters } from 'vuex-smart-module';
import VideosState from './state';

export default class OrganizationGetters extends Getters<VideosState> {}
